import { useEffect, useMemo, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { PageHeader, Surface, Empty } from "../components/Primitives";
import { CreditCard } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Payments() {
  const { user } = useAuth();
  const canEdit = user?.role === "admin" || user?.role === "user";
  const [payments, setPayments] = useState([]);
  const [sales, setSales] = useState([]);
  const [form, setForm] = useState({ sale_id:"", amount:0, method:"espèces", note:"" });

  const load = async () => {
    const [p, s] = await Promise.all([api.get("/payments"), api.get("/sales")]);
    setPayments(p.data); setSales(s.data);
  };
  useEffect(()=>{load();},[]);

  const unpaid = useMemo(() => sales.filter(s => s.balance > 0), [sales]);

  const submit = async e => {
    e.preventDefault();
    try {
      await api.post("/payments", { ...form, amount: Number(form.amount) });
      toast.success("Paiement enregistré");
      setForm({ sale_id:"", amount:0, method:"espèces", note:"" }); load();
    } catch(e){ toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Paiements" subtitle="Encaissements · Reliquats"/>

      {canEdit && (
        <Surface title="Nouveau paiement">
          <form onSubmit={submit} className="p-5 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="md:col-span-2"><label className="label-mono block mb-1.5">Vente</label>
              <select data-testid="pay-sale" required className="input-base" value={form.sale_id} onChange={e=>setForm({...form,sale_id:e.target.value})}>
                <option value="">— Vente impayée —</option>
                {unpaid.map(s => <option key={s.id} value={s.id}>{s.customer_name} · {s.created_at?.slice(0,10)} · Reliquat {s.balance.toFixed(2)} F</option>)}
              </select>
            </div>
            <div><label className="label-mono block mb-1.5">Montant (F)</label><input data-testid="pay-amount" type="number" step="0.01" min="0.01" required className="input-base" value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})}/></div>
            <div><label className="label-mono block mb-1.5">Méthode</label>
              <select className="input-base" value={form.method} onChange={e=>setForm({...form,method:e.target.value})}>
                <option>espèces</option><option>carte</option><option>virement</option><option>chèque</option><option>mobile</option>
              </select>
            </div>
            <div className="col-span-full"><button data-testid="submit-pay" type="submit" className="btn-primary flex items-center gap-2"><CreditCard size={14}/>Encaisser</button></div>
          </form>
        </Surface>
      )}

      <Surface title="Historique des paiements">
        {payments.length === 0 ? <Empty/> : (
          <table className="data-table">
            <thead><tr><th>Date</th><th>Vente</th><th>Montant</th><th>Méthode</th></tr></thead>
            <tbody>
              {payments.map(p => (
                <tr key={p.id}>
                  <td className="font-data text-[var(--text-muted)] text-xs">{p.created_at?.slice(0,16).replace("T"," ")}</td>
                  <td className="font-data text-[var(--text-muted)]">{p.sale_id?.slice(0,8)}</td>
                  <td className="font-data neon-text-green">{p.amount.toLocaleString("fr-FR")} F</td>
                  <td><span className="badge-info">{p.method}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Surface>
    </div>
  );
}
